import { useCallback, useEffect, useState } from 'react';
import { Button, Link } from '@mui/material';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import StarCleanerVisitService from '../../services/StarCleanerVisitService';
import { formatDate } from '../../utils/DateTimeUtils';

interface InputProps {
    houseId: number;
}

const starCleanerVisit = new StarCleanerVisitService();

const COLUMNS: CommonListColumn[] = [
    { label: 'Id', field: 'id' },
    { label: 'Status', field: 'status', type: 'status' },
    {
        label: 'Visit Date',
        render: (row) => formatDate(row?.visitDate) || '-',
    },
    { label: 'Visit Time', field: 'visitTime' },
    { label: 'House Id', field: 'houseId' },
    { label: 'Created By Type', field: 'createdByType' },
    { label: 'Cancellation Reason', field: 'cancellationReason' },
    {
        label: 'Actions',
        stopRowClick: true,
        render: (row) => (
            <Link href={`/#/StarCleaner/${row.id}/show`}>
                <Button variant="contained" color="primary" size="small">Show</Button>
            </Link>
        ),
    },
];

const HouseStarCleanerVisitsTab = ({ houseId }: InputProps) => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const refreshData = useCallback(() => {
        setLoading(true);
        starCleanerVisit
            .getStarCleanerForHouse(houseId)
            .then((res: any) => {
                setData(res?.data ?? []);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [houseId]);

    useEffect(() => {
        refreshData();
    }, [refreshData]);

    return (
        <CommonListTable
            columns={COLUMNS}
            data={data}
            loading={loading}
            emptyText="No Star Cleaner Visit Found"
        />
    );
};

export default HouseStarCleanerVisitsTab;
